/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer components {
  input[type="checkbox"] {
    &[aria-hidden="true"] {
      display: contents;
    }
  }
  .checkbox {
    display: flex;
    width: 1em;
    height: 1em;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm, 0.25rem);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--base-grey-400);
    background-color: var(--base-white);
    font-size: var(--text-base, 1rem);
    line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
    @media (prefers-reduced-motion: no-preference) {
      transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
      transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
    }
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary-500);
      }
    }
    &[data-state="checked"] {
      border-color: currentcolor;
    }
    &[data-state="checked"] {
      background-color: currentcolor;
    }
    &[data-state="checked"] {
      color: var(--color-primary-600);
    }
    &[data-state="checked"] {
      &:hover {
        @media (hover: hover) {
          color: var(--color-primary-500);
        }
      }
    }
    &[data-state="indeterminate"] {
      color: var(--color-primary-600);
    }
    &[data-state="indeterminate"] {
      &:hover {
        @media (hover: hover) {
          color: var(--color-primary-500);
        }
      }
    }
    --tw-ring-color: var(--color-primary-500);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-primary-500) 30%, transparent);
    }
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus-within {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &[aria-disabled="true"] {
      cursor: not-allowed;
    }
    &[aria-disabled="true"] {
      border-color: currentcolor;
    }
    &[aria-disabled="true"] {
      background-color: var(--base-grey-100);
    }
    &[aria-disabled="true"] {
      color: var(--base-grey-400);
    }
    &[aria-disabled="true"] {
      &[data-state="checked"] {
        color: var(--base-grey-500);
      }
    }
    &[aria-disabled="true"] {
      &[data-state="indeterminate"] {
        color: var(--base-grey-500);
      }
    }
    &[aria-busy="true"] {
      cursor: wait;
    }
    &[aria-busy="true"] {
      border-color: currentcolor;
    }
    &[aria-busy="true"] {
      background-color: var(--base-grey-100);
    }
    &[aria-busy="true"] {
      color: var(--base-grey-400);
    }
    &[aria-busy="true"] {
      &[data-state="checked"] {
        color: var(--base-grey-500);
      }
    }
    &[aria-busy="true"] {
      &[data-state="indeterminate"] {
        color: var(--base-grey-500);
      }
    }
  }
  .sm {
    font-size: var(--text-sm, 0.875rem);
    line-height: 1;
  }
  .md {
    font-size: var(--text-base, 1rem);
    line-height: 1;
  }
  .lg {
    font-size: var(--text-lg, 1.125rem);
    line-height: 1;
  }
  .label {
    cursor: pointer;
    color: var(--base-grey-800);
    &:where(&:has(.checkbox[aria-disabled="true"])),	&:where(&:has(.checkbox[aria-busy="true"])) {
      color: var(--base-grey-500);
    }
    &:where(&:has(.checkbox[aria-disabled="true"])) {
      cursor: not-allowed;
    }
    &:where(&:has(.checkbox[aria-busy="true"])) {
      cursor: wait;
    }
    &:where(&:has(.sm)) {
      font-size: var(--text-xs, 0.75rem);
      line-height: 1;
    }
    &:where(&:has(.md)) {
      font-size: var(--text-13, 0.8125rem);
      line-height: 1;
    }
    &:where(&:has(.lg)) {
      font-size: var(--text-sm, 0.875rem);
      line-height: 1;
    }
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
    }
  }
}
